export const colors = {
  purple: '#6B5BA6',
  ligthPurple: '#e8e6f1',
  gray: '#212226',
  darkGray: '#666666',
  pink: '#CAA2F2',
  lightPurplePink: '#d9c4f1',
  white: '#FFFFFF',
  black: '#000000',
  violet: '#753FBF',
  ligthGray: '#d4d4d4',
  ligherGray: '#DDDDDD',
};
